/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export const UnauthorizedRedirectURL = '/login';
export const UnauthorizedManagerRedirectURL = '/login/manager';
export const AuthorizedRedirectURL = '/';
export const AuthorizedManagerRedirectURL = '/_/selection';

export const AuthCookieExpiration = 1; // in days
